import * as React from "react";
import { cn } from "@/lib/cn";

/**
 * Skeleton — Volume 03 §23. Mô phỏng cấu trúc thật, không phải khối trang trí.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn("animate-pulse rounded-md bg-subtle", className)}
      {...props}
    />
  );
}
